export default __webpack_public_path__ + "static/luisbara-95902e79bd4928370d5d0da47548df5c.webp";